import { shouldApplyThemeToRoute } from './bigTopRollout.js';
import { getRegisteredThemeId } from './getRegisteredThemeId.js';
import { getTheme } from './themeRegistry.js';
import { THEME_IDS } from './themeIds.js';

/**
 * Resolve the active theme for the current route + navigation state.
 *
 * @param {string} pathname
 * @param {object | null | undefined} locationState
 */
export function resolveAppTheme(pathname, locationState) {
  const registeredThemeId = getRegisteredThemeId();

  if (registeredThemeId === THEME_IDS.DEFAULT) {
    return getTheme(THEME_IDS.DEFAULT);
  }

  if (shouldApplyThemeToRoute(registeredThemeId, pathname, locationState ?? {})) {
    return getTheme(registeredThemeId);
  }

  return getTheme(THEME_IDS.DEFAULT);
}
